<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!paymentMethod">
      <span class="loader"></span>
    </span>
    <payment-method-form
      v-if="paymentMethod"
      :loading="loading"
      :paymentMethodData="paymentMethod"
      :formErrors="formErrors"
      @paymentMethodSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
      @cancelEdition="cancelEdition"
    />
  </div>
</template>

<script>
import PaymentMethodForm from "../partials/PaymentMethodForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";

export default {
  layout: "DashboardLayout",

  components: { PaymentMethodForm },

  mixins: [alertLeave],

  props: {
    paymentMethodId: {
      type: [String, Number],
      required: true,
    }
  },

  data() {
    return {
      paymentMethod: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    cancelEdition() {
      this.$emit("cancelEdition");
    },
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("paymentMethods/get", this.paymentMethodId);
        this.paymentMethod =
          this.$store.getters["paymentMethods/paymentMethod"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.loading = false;
      }
    },

    async handleSubmit(paymentMethod) {
      this.loading = true;
      const paymentMethodData = cloneDeep(paymentMethod);

      try {
        await this.$store.dispatch("paymentMethods/update", paymentMethodData);
        this.$notify({
          type: "success",
          message: this.$t("PAYMENT_METHODS.PAYMENT_METHOD_UPDATED"),
        });
        const paymentMethod = await this.$store.getters[
          "paymentMethods/paymentMethod"
        ];
        this.$emit("onViewPaymentMethod", paymentMethod, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
